import { NgModule } from '@angular/core';
import { LiveSearchSelectComponent } from './live-search-select.component';
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import {RouterLink} from "@angular/router";
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
    declarations: [
        LiveSearchSelectComponent,
    ],
    exports: [
        LiveSearchSelectComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterLink,
        NgbTooltipModule,
    ]
})
export class LiveSearchSelectModule { }